module.exports = __webpack_public_path__ + "img/como_lo_hacemos_link2.d04c299a.png";